import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';
import CartAction from 'actions/Cart';
import TagManagerService from 'services/TagManager';
import PubSub from "services/PubSub";
import { addClass, removeClass } from 'utils';
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss'; //NOSONAR

let action = [];

const Cupon = (props) => {
    const [cuponDefault, setCuponDefault] = useState('');
    const [viewError, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isvalid, setIsvalid] = useState(false);
    const [open, setOpen] = useState(false);

    const isMobile = useViewportMediaQuery(1024)
    const notMobile = props.notMobile;
    let input = useRef();

    useEffect(() => {
        action.push(PubSub.register('coupon_open', _open));

        return function cleanup() {
            action.map(token => PubSub.unregister(token));
            action = [];
        }
    }, []);

    const _open = () => {
        setOpen(true);
    }

    const updateDefaultCupon = () => {
        if(props.orderform) {
            setLoading(false);
            setCuponDefault(props.orderform.marketingData ? props.orderform.marketingData.coupon : '');

        }
    };

    useEffect(updateDefaultCupon, []);
    useEffect(updateDefaultCupon,[props.orderform]);

    const applicateCupon = (cupon) => {
        if(cupon === '') return false;
        setLoading(true);
        setError(false);
        CartAction.setCupon(cupon).then(orderForm => {
            const isValid = orderForm && orderForm.marketingData.coupon === cupon;
            if(isValid){
                setCuponDefault(cupon);
                setIsvalid(true);

                if(props.isQuickPurchase) {
                    TagManagerService.interactionQuickPurchase('Clic', 'Aplicar cupón', 'Compra rápida');
                } else {
                    TagManagerService.interaction('Aplicar cupón', cupon , 'Resumen de compra');
                }
            }
            setError(!isValid);
            setIsvalid(false);
            setLoading(false);
            if(!cupon){
                setCuponDefault(cupon);
                input.current.value = '';
                setIsvalid(true);
                setError(false);
            }
        });
    };

    const formIsValid = () => {
        const validInput = input.current && input.current.value;
        if((!!validInput !== isvalid) || validInput.length === 0){
            setIsvalid(!!validInput);
        }
        setError(false);
    }


    const onSubmit = (event) => {
        event.preventDefault();

        if(!cuponDefault){
            applicateCupon(input.current.value);
        }
    };

    if(isMobile && notMobile) return '';

    if(open && isMobile){
        setTimeout(()=>  PubSub.dispatch('cart_update_title',{title: 'Agrega tu cupón'}),0);
        addClass(document.documentElement, 'non-scroll');
    }else{
        removeClass(document.documentElement, 'non-scroll');
    }
    
    return (
        <form className="new-cart-cupon" onSubmit={onSubmit}>
            <h3 className="new-cart-cupon-title">Cupón</h3>
            <div className="new-cart-cupon-wrapper input-wrapper">
                <input 
                    className={"new-cart-cupon-input input-default" + (cuponDefault ? ' valid' : '') + (loading ? ' input-loading': '') + ((viewError && !cuponDefault) ? ' input-error' : '')}
                    placeholder="Ej: AODFJ981378920218"
                    defaultValue={cuponDefault}
                    ref={input}
                    onChange={formIsValid}
                />
                {!cuponDefault && <button className={"new-cart-cupon-button" + (isvalid ? ' primary-btn' : ' disabled-btn')} type="submit" >Aplicar</button>}
                {cuponDefault && <button className="new-cart-cupon-button primary-btn" type='button' onClick={() => applicateCupon(false)}>Eliminar</button>}
                {cuponDefault && !loading && <span className="new-cart-cupon-check font-icn check"></span>}
                {(viewError && !cuponDefault) && <i className="jumbo-icon-new-close"></i>}
                {loading && <span className="new-cart-cupon-loader"><Loader/></span>}
                {viewError && !cuponDefault && <span className="input-error-message">Cupón incorrecto, intente otra vez</span>}
            </div>
        </form>
    )
};

Cupon.propTypes = {
    orderform: PropTypes.object,
    notMobile: PropTypes.bool,
    isQuickPurchase: PropTypes.bool
};

export default Cupon;
